import React, { useState, useEffect } from 'react';
import styles from './HeroCarousel.module.css';

const images = [
  {
    src: 'https://assets.cinbiosis.com/reel_landing/cinbiosis1.jpeg',
    alt: 'Equipo de CINBIOSIS realizando muestreo biológico en campo en Colombia',
  },
  {
    src: 'https://assets.cinbiosis.com/reel_landing/cinbiosis2.jpg',
    alt: 'Monitoreo de fauna y flora en zona de influencia directa de corredor vial',
  },
  {
    src: 'https://assets.cinbiosis.com/reel_landing/cinbiosis3.jpeg',
    alt: 'Levantamiento fotogramétrico con UAV para inventario dendrológico y polígonos de compensación ambiental',
  },
  {
    src: 'https://assets.cinbiosis.com/reel_landing/cinbiosis4.jpeg',
    alt: 'Profesionales de CINBIOSIS ejecutando consultoría de licenciamiento ambiental y servicios geoespaciales',
  },
];

const HeroCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // Preload images to warm browser cache immediately
    images.forEach(({ src }) => {
      const img = new Image();
      img.src = src;
    });

    // Advance slide every 3.5 seconds
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3500);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles.carouselContainer}>
      {images.map(({ src, alt }, index) => (
        <img
          key={index}
          src={src}
          alt={alt}
          className={`${styles.carouselImage} ${index === currentIndex ? styles.active : ''}`}
        />
      ))}
    </div>
  );
};

export default HeroCarousel;
